import { render, staticRenderFns } from "./MedicalCase.vue?vue&type=template&id=7ed89daa&"
import script from "./MedicalCase.vue?vue&type=script&lang=js&"
export * from "./MedicalCase.vue?vue&type=script&lang=js&"
import style0 from "./MedicalCase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports